// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import LazyImage from "@store/MobiusOverrides/LazyImage/LazyImage";
import constants from "@store/constants";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import * as React from "react";
import { css } from "styled-components";

interface ProductIconBadgeProps {
    extendedStyles?: ProductIconBadgeStyles;
    src?: string;
}

type Props = ProductIconBadgeProps & HasProduct;

export interface ProductIconBadgeStyles {
    wrapper?: InjectableCss;
}

export const productIconBadgeStyles: ProductIconBadgeStyles = {
    wrapper: {
        css: css`
            height: auto;
        `,
    },
};

const ProductIconBadge: React.FC<Props> = ({ product: { attributeTypes }, src, extendedStyles }) => {
    const styles = useMergeProps(productIconBadgeStyles, extendedStyles);

    const iconBadgeAttribute = attributeTypes?.find(attr => attr.name === constants.productAttributes.iconBadgeGauge);
    const iconBadgeValue = iconBadgeAttribute?.attributeValues?.[0]?.value;

    const iconBadgeSrc = src ?? iconBadgeValue;

    if (!iconBadgeSrc) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <LazyImage src={iconBadgeSrc} altText={translate("Gauge Badge Icon")} />
        </StyledWrapper>
    );
};

export default withProduct(ProductIconBadge);
